import _store from "store2";
import {
    getMailCustomerLevelList,
    addMailCustomerFollowLevel,
    editMailCustomerLevel,
    getCustomerSelectData, getCustomerProduct, getCustomerOrigin
} from "@/api/customer.js";
import {ElMessage} from "element-plus";
import {moveEmptyToEndAndSort, sortFolders} from "@/utils/util";
import sessionStore from "@/utils/sessionStore";

const customer = {
    namespaced: true,
    state: {
        tableData: sortFolders(sessionStore.get("customerLevel")) || [],
        customerSelectData: sessionStore.get('customerSelectData') || []
    },
    mutations: {
        // 改变编辑状态
        changeEditing(state, payload) {
            const {index, flag} = payload;
            state.tableData[index].editing = flag;
        },
        setCustomerSelectData(state, payload) {
            state.customerSelectData = payload;
            sessionStore.set('customerSelectData', payload)
        },

    },
    actions: {
        // 获取等级列表
        async getMailCustomerLevel({state, dispatch, rootState}, payload) {
            let isUpdate = false
            if (payload) {
                isUpdate = payload.isUpdate
            }
            const {teamId} = payload
            // if (!sessionStore.get("customerLevel") |) {
            // const teamId = localStorage.getItem("teamId")
            let res = await getMailCustomerLevelList({teamId, pageSize: 30});
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return;
            }
            const {records} = res.result;
            let addEditing = records.map((item) => {
                return {...item, editing: false};
            });
            state.tableData = sortFolders(addEditing);
            sessionStore.set("customerLevel", addEditing)
            // }
        },
        //获取下拉框数据
        async getCustomerSelectDataFunction({state, commit}, payload) {
            console.log("payload", payload)
            try {
                const res = await getCustomerSelectData(payload)
                if (res.code !== 200) {
                    ElMessage.error(res.message)
                    return
                }
                const result = res.result
                if (Array.isArray(result.productList)) {
                    result.productList = moveEmptyToEndAndSort(result.productList.filter(_ => _ !== ""))
                }
                if (Array.isArray(result.customerOriginList)) {
                    result.customerOriginList = moveEmptyToEndAndSort([...result.customerOriginList.filter(_ => _ !== "")])
                }
                state.customerSelectData = result
                localStorage.setItem('customerSelectData', JSON.stringify(result))
                console.log(state.customerSelectData, 'state.customerSelectData')
            } catch (error) {
                ElMessage.error('获取数据失败')
                console.error(error)
            }
        },
        // 获取意向产品的下拉数据
        async getCustomerProductList({state, commit}, payload) {
            try {
                const res = await getCustomerProduct(payload)
                if (res.code !== 200) {
                    ElMessage.error(res.message)
                    return
                }
                console.log(res, 'resProduct')
            } catch (e) {

            }
        },
        // 获取客户来源的下拉数据
        async getCustomerOriginList({state, commit}, payload) {
            try {
                const res = await getCustomerOrigin(payload)
                if (res.code !== 200) {
                    ElMessage.error(res.message)
                    return
                }
            } catch (e) {

            }
        },
        async addCustomerData(state, targetParams) {
            let res = await addMailCustomerFollowLevel(targetParams);
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return;
            }
            // ElMessage.success(res.result);
        },
        async editCustomerData(state, targetParams) {
            let res = await editMailCustomerLevel(targetParams);
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return;
            }
            // ElMessage.success(res.result);
        },
    },
};

export default customer;
